export default class ShopSchedule extends HTMLDivElement{
    constructor() {
        super();
    }

    connectedCallback() {
        this.initSchedule();
    }

    initSchedule() {
        var paramThis = this;

        $(this).find('.scheduleDay').each(function(){
            var newType    = $(this).find('select.select_type').val();
            var currentDay = $(this).attr('id');

            paramThis.updateDayLine(currentDay, newType);
        });

        // Listen for changes on any day type select box
        $(this).find('.select_type').on('change', function(){
            var newType    = $(this).val();
            var currentDay = $(this).closest('.scheduleDay').attr('id');

            paramThis.updateDayLine(currentDay, newType);
        });
    }

    updateDayLine(id, newType) {
        var dayLine = $('#'+id);
        var closedSign = 'fermé'.toUpperCase();

        if ( dayLine !== undefined && dayLine.length > 0 ){
            newType = parseInt(newType);

            this.initDayLineStatus(dayLine);

            switch (newType){
                case 1:
                default:
                    // On force l'affichage des 2 périodes
                    this.manageDayLineHours(dayLine, true, true, true, true);

                    dayLine.find('.period_pm_end').removeClass('offset-6');

                    break;
                case 2:
                    // On cache l'après midi et on affiche FERME à la place
                    this.manageDayLineHours(dayLine, true, true, false, false);
                    this.manageDayLineStatus(dayLine, 'period_pm_status', false, closedSign);

                    dayLine.find('.period_pm_end').removeClass('offset-6');

                    break;
                case 3:
                    // On cache le matin et on affiche FERME à la place
                    this.manageDayLineHours(dayLine, false, false, true, true);
                    this.manageDayLineStatus(dayLine, 'period_am_status', false, closedSign);

                    dayLine.find('.period_pm_end').removeClass('offset-6');

                    break;
                case 4:
                    // On cache tous les champs heure et on affiche le texte 24h/24
                    this.manageDayLineHours(dayLine, false, false, false, false);
                    this.manageDayLineStatus(dayLine, 'period_inter', true, '24H/24');

                    dayLine.find('.period_am').addClass('hide');
                    dayLine.find('.period_pm').addClass('hide');
                    dayLine.find('.period_pm_end').removeClass('offset-6');

                    break;
                case 5:
                    // On force l'affichage des 2 périodes extrèmes
                    this.manageDayLineHours(dayLine, true, false, false, true);

                    dayLine.find('.period_pm_end').addClass('offset-6');

                    break;
                case 6:
                    // On cache tous les champs heure et on affiche le texte FERME centré sur toute la cellule
                    this.manageDayLineHours(dayLine, false, false, false, false);
                    this.manageDayLineStatus(dayLine, 'period_inter', false, closedSign);

                    dayLine.find('.period_am').addClass('hide');
                    dayLine.find('.period_pm').addClass('hide');
                    dayLine.find('.period_pm_end').removeClass('offset-6');

                    break;
            }
        }
    }

    manageDayLineHours(dayLine, am_begin, am_end, pm_begin, pm_end){
        this.manageDayLinePeriod(dayLine, 'period_am_begin', am_begin);
        this.manageDayLinePeriod(dayLine, 'period_am_end', am_end);
        this.manageDayLinePeriod(dayLine, 'period_pm_begin', pm_begin);
        this.manageDayLinePeriod(dayLine, 'period_pm_end', pm_end);
    }

    manageDayLinePeriod(dayLine, period_class, period_active){
        if (period_active){
            dayLine.find('.'+period_class).removeClass('hide');
        }
        else{
            dayLine.find('.'+period_class).addClass('hide');
        }
    }

    manageDayLineStatus(dayLine, period_class, status, text){
        if ( status ) {
            dayLine.find('.' + period_class).removeClass('hide').addClass('open').html(text);
        } else {
            dayLine.find('.' + period_class).removeClass('hide').addClass('closed').html(text);
        }
    }

    initDayLineStatus(dayLine){
        dayLine.find('.period_am').removeClass('hide');
        dayLine.find('.period_pm').removeClass('hide');
        dayLine.find('.period_am_status').addClass('hide').removeClass('closed open');
        dayLine.find('.period_pm_status').addClass('hide').removeClass('closed open');
        dayLine.find('.period_inter').addClass('hide').removeClass('closed open');
    }
}